import React, { useEffect, useState } from "react";
import client, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { OctagonX, Send, MessageCircle, Smartphone } from "lucide-react";
import { Panel } from "./ui-kit";

const CH = [["telegram", "Free Telegram", Send], ["whatsapp", "Free WhatsApp", MessageCircle], ["app", "App (free users + push)", Smartphone]];

export function FreeKillSwitch() {
  const [st, setSt] = useState(null);
  useEffect(() => { client.get("/free-pause").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  const flip = async (k) => {
    try {
      const { data } = await client.put("/free-pause", { [k]: !st[k] });
      setSt(data);
      toast.success(`${CH.find((c) => c[0] === k)[1]} ${data[k] ? "OFF — free signals ruk gaye" : "ON"}`);
    } catch (e) { toast.error(apiErr(e)); }
  };
  if (!st) return null;
  const any = CH.some(([k]) => st[k]);
  return (
    <Panel title="Free signals kill switch" testid="free-kill-switch" className="mb-5"
      right={<span className={`text-[11px] font-semibold ${any ? "text-bear" : "text-bull"}`} data-testid="kill-status">{any ? "Kuch free channel band hain" : "Sab free channel ON"}</span>}>
      <div className="p-4">
        <div className="grid sm:grid-cols-3 gap-2">
          {CH.map(([k, l, Icon]) => (
            <button key={k} onClick={() => flip(k)} data-testid={`kill-${k}`}
              className={`flex items-center gap-3 px-4 py-3 border text-left transition-colors duration-200 ${st[k] ? "border-bear/60 bg-[rgba(239,68,68,0.08)]" : "border-[color:var(--border-subtle)] hover:border-gold"}`}>
              {st[k] ? <OctagonX size={18} className="text-bear shrink-0" /> : <Icon size={18} className="text-bull shrink-0" />}
              <div className="min-w-0">
                <div className="text-sm text-white">{l}</div>
                <div className={`text-[11px] ${st[k] ? "text-bear" : "text-slate-500"}`} data-testid={`kill-${k}-state`}>{st[k] ? "OFF — kuch nahi jayega" : "ON — signals ja rahe hain"}</div>
              </div>
            </button>
          ))}
        </div>
        <p className="text-[11px] text-slate-500 mt-3">OFF hone par VIP se aane wale signals aur updates us free channel me nahi jayenge. VIP Telegram, VIP WhatsApp group aur Scalper channel pe koi asar nahi. Manual "Send Signal" bhi chalta rahega. Telegram bot me admin: /free_off, /free_on, /free_status (ya /free_off telegram|whatsapp|app).</p>
      </div>
    </Panel>
  );
}
